import type { productsPrintTypesQuery$data } from '../../pages/printType/__generated__/productsPrintTypesQuery.graphql';
import { toLocalID } from 'src/shared/helpers';
import type { PrintingMethodAssignment } from './types';

/** Resolve display labels from the seller's catalogue without changing the draft's assignments. */
export const resolvePrintingMethodAssignments = (
    assignments: readonly PrintingMethodAssignment[],
    products: productsPrintTypesQuery$data['modelsHierarchy']
) => {
    const productsById = new Map(products.map((product) => [toLocalID(product.productID), product]));
    return assignments.flatMap((assignment) => {
        const product = productsById.get(assignment.productId);
        // A name stored in an old draft is not evidence that the product still exists.
        if (!product?.name.trim()) return [];
        const sides = (assignment.sides ?? []).flatMap((reference) => {
            const color = product.colors.find((item) => toLocalID(item.colorID) === reference.colorId);
            const side = color?.sides.find((item) => toLocalID(item.sideID) === reference.sideId);
            if (!color || !side?.name.trim()) return [];
            if (product.colors.length === 1 && toLocalID(color.colorID) === 1) return [side.name];
            return [color.name.trim() ? `${color.name} · ${side.name}` : side.name];
        });
        return [
            {
                productId: assignment.productId,
                productName: product.name,
                productCode: product.code,
                allSides: !assignment.sides?.length,
                sides
            }
        ];
    });
};
